module.exports = __webpack_public_path__ + "static/media/mejora_continua_2025_800.25c8e28a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mejora_continua_2025_800.png
// module id = 471
// module chunks = 1